import {useMutation, useQueryClient} from '@tanstack/react-query';
import {useNotifications} from '../../../shared';
import {fundraiserDocumentsApi} from '../api';
import {CreateFundraiserDocumentDTO} from '../model';

export const useCreateFundraiserDocument = () => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const createDocumentMutation = useMutation({
    mutationFn: ({appealId, dto}: {appealId: string; dto: CreateFundraiserDocumentDTO}) =>
      fundraiserDocumentsApi.createDocument(appealId, dto),
    onSuccess: (_, {appealId}) => {
      // Инвалидируем кеш документов для данного сбора
      queryClient.invalidateQueries({
        queryKey: ['fundraiser-documents', 'infinite', appealId],
        refetchType: 'all',
      });

      createNotification({
        title: 'Документ успешно создан',
        name: 'createDocument',
        theme: 'success',
      });
    },
    onError: (error: Error) => {
      createNotification({
        title: 'Ошибка при создании документа',
        name: 'createDocumentError',
        content: error.message,
        theme: 'danger',
      });
    },
  });

  return {
    createDocumentMutation,
  };
};
